"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolReserve = exports.RemovePoolRoutes = exports.RemoveLiquidities = exports.RemoveLiquidity = exports.AddLiquidities = exports.AddLiquidity = exports.PoolRoute = exports.Pools = exports.Pool = exports.Params = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = "Switcheo.carbon.liquiditypool";
const baseParams = {
    rewardReductionThreshold: long_1.default.UZERO,
    numQuotes: long_1.default.UZERO,
};
exports.Params = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.rewardReductionThreshold.isZero()) {
            writer.uint32(8).uint64(message.rewardReductionThreshold);
        }
        if (!message.numQuotes.isZero()) {
            writer.uint32(16).uint64(message.numQuotes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewardReductionThreshold = reader.uint64();
                    break;
                case 2:
                    message.numQuotes = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseParams);
        message.rewardReductionThreshold =
            object.rewardReductionThreshold !== undefined &&
                object.rewardReductionThreshold !== null
                ? long_1.default.fromString(object.rewardReductionThreshold)
                : long_1.default.UZERO;
        message.numQuotes =
            object.numQuotes !== undefined && object.numQuotes !== null
                ? long_1.default.fromString(object.numQuotes)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rewardReductionThreshold !== undefined &&
            (obj.rewardReductionThreshold = (message.rewardReductionThreshold || long_1.default.UZERO).toString());
        message.numQuotes !== undefined &&
            (obj.numQuotes = (message.numQuotes || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseParams);
        message.rewardReductionThreshold =
            object.rewardReductionThreshold !== undefined &&
                object.rewardReductionThreshold !== null
                ? long_1.default.fromValue(object.rewardReductionThreshold)
                : long_1.default.UZERO;
        message.numQuotes =
            object.numQuotes !== undefined && object.numQuotes !== null
                ? long_1.default.fromValue(object.numQuotes)
                : long_1.default.UZERO;
        return message;
    },
};
const basePool = {
    creator: "",
    id: long_1.default.UZERO,
    name: "",
    denom: "",
    denomA: "",
    amountA: "",
    weightA: "",
    denomB: "",
    amountB: "",
    weightB: "",
    swapFee: "",
    sharesAmount: "",
    ampBps: long_1.default.UZERO,
    vAmountA: "",
    vAmountB: "",
};
exports.Pool = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.id.isZero()) {
            writer.uint32(16).uint64(message.id);
        }
        if (message.name !== "") {
            writer.uint32(26).string(message.name);
        }
        if (message.denom !== "") {
            writer.uint32(34).string(message.denom);
        }
        if (message.denomA !== "") {
            writer.uint32(42).string(message.denomA);
        }
        if (message.amountA !== "") {
            writer.uint32(50).string(message.amountA);
        }
        if (message.weightA !== "") {
            writer.uint32(58).string(message.weightA);
        }
        if (message.denomB !== "") {
            writer.uint32(66).string(message.denomB);
        }
        if (message.amountB !== "") {
            writer.uint32(74).string(message.amountB);
        }
        if (message.weightB !== "") {
            writer.uint32(82).string(message.weightB);
        }
        if (message.swapFee !== "") {
            writer.uint32(90).string(message.swapFee);
        }
        if (message.sharesAmount !== "") {
            writer.uint32(106).string(message.sharesAmount);
        }
        if (!message.ampBps.isZero()) {
            writer.uint32(120).uint64(message.ampBps);
        }
        if (message.vAmountA !== "") {
            writer.uint32(130).string(message.vAmountA);
        }
        if (message.vAmountB !== "") {
            writer.uint32(138).string(message.vAmountB);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basePool);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.id = reader.uint64();
                    break;
                case 3:
                    message.name = reader.string();
                    break;
                case 4:
                    message.denom = reader.string();
                    break;
                case 5:
                    message.denomA = reader.string();
                    break;
                case 6:
                    message.amountA = reader.string();
                    break;
                case 7:
                    message.weightA = reader.string();
                    break;
                case 8:
                    message.denomB = reader.string();
                    break;
                case 9:
                    message.amountB = reader.string();
                    break;
                case 10:
                    message.weightB = reader.string();
                    break;
                case 11:
                    message.swapFee = reader.string();
                    break;
                case 13:
                    message.sharesAmount = reader.string();
                    break;
                case 15:
                    message.ampBps = reader.uint64();
                    break;
                case 16:
                    message.vAmountA = reader.string();
                    break;
                case 17:
                    message.vAmountB = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, basePool);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromString(object.id)
                : long_1.default.UZERO;
        message.name =
            object.name !== undefined && object.name !== null
                ? String(object.name)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.denomA =
            object.denomA !== undefined && object.denomA !== null
                ? String(object.denomA)
                : "";
        message.amountA =
            object.amountA !== undefined && object.amountA !== null
                ? String(object.amountA)
                : "";
        message.weightA =
            object.weightA !== undefined && object.weightA !== null
                ? String(object.weightA)
                : "";
        message.denomB =
            object.denomB !== undefined && object.denomB !== null
                ? String(object.denomB)
                : "";
        message.amountB =
            object.amountB !== undefined && object.amountB !== null
                ? String(object.amountB)
                : "";
        message.weightB =
            object.weightB !== undefined && object.weightB !== null
                ? String(object.weightB)
                : "";
        message.swapFee =
            object.swapFee !== undefined && object.swapFee !== null
                ? String(object.swapFee)
                : "";
        message.sharesAmount =
            object.sharesAmount !== undefined && object.sharesAmount !== null
                ? String(object.sharesAmount)
                : "";
        message.ampBps =
            object.ampBps !== undefined && object.ampBps !== null
                ? long_1.default.fromString(object.ampBps)
                : long_1.default.UZERO;
        message.vAmountA =
            object.vAmountA !== undefined && object.vAmountA !== null
                ? String(object.vAmountA)
                : "";
        message.vAmountB =
            object.vAmountB !== undefined && object.vAmountB !== null
                ? String(object.vAmountB)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.id !== undefined &&
            (obj.id = (message.id || long_1.default.UZERO).toString());
        message.name !== undefined && (obj.name = message.name);
        message.denom !== undefined && (obj.denom = message.denom);
        message.denomA !== undefined && (obj.denomA = message.denomA);
        message.amountA !== undefined && (obj.amountA = message.amountA);
        message.weightA !== undefined && (obj.weightA = message.weightA);
        message.denomB !== undefined && (obj.denomB = message.denomB);
        message.amountB !== undefined && (obj.amountB = message.amountB);
        message.weightB !== undefined && (obj.weightB = message.weightB);
        message.swapFee !== undefined && (obj.swapFee = message.swapFee);
        message.sharesAmount !== undefined &&
            (obj.sharesAmount = message.sharesAmount);
        message.ampBps !== undefined &&
            (obj.ampBps = (message.ampBps || long_1.default.UZERO).toString());
        message.vAmountA !== undefined && (obj.vAmountA = message.vAmountA);
        message.vAmountB !== undefined && (obj.vAmountB = message.vAmountB);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const message = Object.assign({}, basePool);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromValue(object.id)
                : long_1.default.UZERO;
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.denomA = (_d = object.denomA) !== null && _d !== void 0 ? _d : "";
        message.amountA = (_e = object.amountA) !== null && _e !== void 0 ? _e : "";
        message.weightA = (_f = object.weightA) !== null && _f !== void 0 ? _f : "";
        message.denomB = (_g = object.denomB) !== null && _g !== void 0 ? _g : "";
        message.amountB = (_h = object.amountB) !== null && _h !== void 0 ? _h : "";
        message.weightB = (_j = object.weightB) !== null && _j !== void 0 ? _j : "";
        message.swapFee = (_k = object.swapFee) !== null && _k !== void 0 ? _k : "";
        message.sharesAmount = (_l = object.sharesAmount) !== null && _l !== void 0 ? _l : "";
        message.ampBps =
            object.ampBps !== undefined && object.ampBps !== null
                ? long_1.default.fromValue(object.ampBps)
                : long_1.default.UZERO;
        message.vAmountA = (_m = object.vAmountA) !== null && _m !== void 0 ? _m : "";
        message.vAmountB = (_o = object.vAmountB) !== null && _o !== void 0 ? _o : "";
        return message;
    },
};
const basePools = {};
exports.Pools = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.pools) {
            exports.Pool.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basePools);
        message.pools = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pools.push(exports.Pool.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, basePools);
        message.pools = ((_a = object.pools) !== null && _a !== void 0 ? _a : []).map((e) => exports.Pool.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.pools) {
            obj.pools = message.pools.map((e) => (e ? exports.Pool.toJSON(e) : undefined));
        }
        else {
            obj.pools = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, basePools);
        message.pools = ((_a = object.pools) !== null && _a !== void 0 ? _a : []).map((e) => exports.Pool.fromPartial(e));
        return message;
    },
};
const basePoolRoute = {
    market: "",
    poolIds: long_1.default.UZERO,
    numQuotes: long_1.default.ZERO,
};
exports.PoolRoute = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.market !== "") {
            writer.uint32(10).string(message.market);
        }
        writer.uint32(18).fork();
        for (const v of message.poolIds) {
            writer.uint64(v);
        }
        writer.ldelim();
        if (!message.numQuotes.isZero()) {
            writer.uint32(24).int64(message.numQuotes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basePoolRoute);
        message.poolIds = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.market = reader.string();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.poolIds.push(reader.uint64());
                        }
                    }
                    else {
                        message.poolIds.push(reader.uint64());
                    }
                    break;
                case 3:
                    message.numQuotes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, basePoolRoute);
        message.market =
            object.market !== undefined && object.market !== null
                ? String(object.market)
                : "";
        message.poolIds = ((_a = object.poolIds) !== null && _a !== void 0 ? _a : []).map((e) => long_1.default.fromString(e));
        message.numQuotes =
            object.numQuotes !== undefined && object.numQuotes !== null
                ? long_1.default.fromString(object.numQuotes)
                : long_1.default.ZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.market !== undefined && (obj.market = message.market);
        if (message.poolIds) {
            obj.poolIds = message.poolIds.map((e) => (e || long_1.default.UZERO).toString());
        }
        else {
            obj.poolIds = [];
        }
        message.numQuotes !== undefined &&
            (obj.numQuotes = (message.numQuotes || long_1.default.ZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, basePoolRoute);
        message.market = (_a = object.market) !== null && _a !== void 0 ? _a : "";
        message.poolIds = ((_b = object.poolIds) !== null && _b !== void 0 ? _b : []).map((e) => long_1.default.fromValue(e));
        message.numQuotes =
            object.numQuotes !== undefined && object.numQuotes !== null
                ? long_1.default.fromValue(object.numQuotes)
                : long_1.default.ZERO;
        return message;
    },
};
const baseAddLiquidity = {
    creator: "",
    id: long_1.default.UZERO,
    amountA: "",
    amountB: "",
    minShares: "",
};
exports.AddLiquidity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.id.isZero()) {
            writer.uint32(16).uint64(message.id);
        }
        if (message.amountA !== "") {
            writer.uint32(26).string(message.amountA);
        }
        if (message.amountB !== "") {
            writer.uint32(34).string(message.amountB);
        }
        if (message.minShares !== "") {
            writer.uint32(42).string(message.minShares);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAddLiquidity);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.id = reader.uint64();
                    break;
                case 3:
                    message.amountA = reader.string();
                    break;
                case 4:
                    message.amountB = reader.string();
                    break;
                case 5:
                    message.minShares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseAddLiquidity);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromString(object.id)
                : long_1.default.UZERO;
        message.amountA =
            object.amountA !== undefined && object.amountA !== null
                ? String(object.amountA)
                : "";
        message.amountB =
            object.amountB !== undefined && object.amountB !== null
                ? String(object.amountB)
                : "";
        message.minShares =
            object.minShares !== undefined && object.minShares !== null
                ? String(object.minShares)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.id !== undefined &&
            (obj.id = (message.id || long_1.default.UZERO).toString());
        message.amountA !== undefined && (obj.amountA = message.amountA);
        message.amountB !== undefined && (obj.amountB = message.amountB);
        message.minShares !== undefined && (obj.minShares = message.minShares);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseAddLiquidity);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromValue(object.id)
                : long_1.default.UZERO;
        message.amountA = (_b = object.amountA) !== null && _b !== void 0 ? _b : "";
        message.amountB = (_c = object.amountB) !== null && _c !== void 0 ? _c : "";
        message.minShares = (_d = object.minShares) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
const baseAddLiquidities = {};
exports.AddLiquidities = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.addLiquidities) {
            exports.AddLiquidity.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAddLiquidities);
        message.addLiquidities = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.addLiquidities.push(exports.AddLiquidity.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseAddLiquidities);
        message.addLiquidities = ((_a = object.addLiquidities) !== null && _a !== void 0 ? _a : []).map((e) => exports.AddLiquidity.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.addLiquidities) {
            obj.addLiquidities = message.addLiquidities.map((e) => e ? exports.AddLiquidity.toJSON(e) : undefined);
        }
        else {
            obj.addLiquidities = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseAddLiquidities);
        message.addLiquidities = ((_a = object.addLiquidities) !== null && _a !== void 0 ? _a : []).map((e) => exports.AddLiquidity.fromPartial(e));
        return message;
    },
};
const baseRemoveLiquidity = { creator: "", id: long_1.default.UZERO, amount: "" };
exports.RemoveLiquidity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.id.isZero()) {
            writer.uint32(16).uint64(message.id);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRemoveLiquidity);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.id = reader.uint64();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRemoveLiquidity);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromString(object.id)
                : long_1.default.UZERO;
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.id !== undefined &&
            (obj.id = (message.id || long_1.default.UZERO).toString());
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseRemoveLiquidity);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromValue(object.id)
                : long_1.default.UZERO;
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseRemoveLiquidities = {};
exports.RemoveLiquidities = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.removeLiquidities) {
            exports.RemoveLiquidity.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRemoveLiquidities);
        message.removeLiquidities = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.removeLiquidities.push(exports.RemoveLiquidity.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseRemoveLiquidities);
        message.removeLiquidities = ((_a = object.removeLiquidities) !== null && _a !== void 0 ? _a : []).map((e) => exports.RemoveLiquidity.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.removeLiquidities) {
            obj.removeLiquidities = message.removeLiquidities.map((e) => e ? exports.RemoveLiquidity.toJSON(e) : undefined);
        }
        else {
            obj.removeLiquidities = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseRemoveLiquidities);
        message.removeLiquidities = ((_a = object.removeLiquidities) !== null && _a !== void 0 ? _a : []).map((e) => exports.RemoveLiquidity.fromPartial(e));
        return message;
    },
};
const baseRemovePoolRoutes = {};
exports.RemovePoolRoutes = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.removePoolRoutes) {
            writer.uint32(10).bytes(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRemovePoolRoutes);
        message.removePoolRoutes = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.removePoolRoutes.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseRemovePoolRoutes);
        message.removePoolRoutes = ((_a = object.removePoolRoutes) !== null && _a !== void 0 ? _a : []).map((e) => bytesFromBase64(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.removePoolRoutes) {
            obj.removePoolRoutes = message.removePoolRoutes.map((e) => base64FromBytes(e !== undefined ? e : new Uint8Array()));
        }
        else {
            obj.removePoolRoutes = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseRemovePoolRoutes);
        message.removePoolRoutes = ((_a = object.removePoolRoutes) !== null && _a !== void 0 ? _a : []).map((e) => e);
        return message;
    },
};
const basePoolReserve = {
    id: long_1.default.UZERO,
    amountA: "",
    weightA: "",
    amountB: "",
    weightB: "",
    vAmountA: "",
    vAmountB: "",
};
exports.PoolReserve = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.id.isZero()) {
            writer.uint32(8).uint64(message.id);
        }
        if (message.amountA !== "") {
            writer.uint32(18).string(message.amountA);
        }
        if (message.weightA !== "") {
            writer.uint32(26).string(message.weightA);
        }
        if (message.amountB !== "") {
            writer.uint32(34).string(message.amountB);
        }
        if (message.weightB !== "") {
            writer.uint32(42).string(message.weightB);
        }
        if (message.vAmountA !== "") {
            writer.uint32(50).string(message.vAmountA);
        }
        if (message.vAmountB !== "") {
            writer.uint32(58).string(message.vAmountB);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basePoolReserve);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.amountA = reader.string();
                    break;
                case 3:
                    message.weightA = reader.string();
                    break;
                case 4:
                    message.amountB = reader.string();
                    break;
                case 5:
                    message.weightB = reader.string();
                    break;
                case 6:
                    message.vAmountA = reader.string();
                    break;
                case 7:
                    message.vAmountB = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, basePoolReserve);
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromString(object.id)
                : long_1.default.UZERO;
        message.amountA =
            object.amountA !== undefined && object.amountA !== null
                ? String(object.amountA)
                : "";
        message.weightA =
            object.weightA !== undefined && object.weightA !== null
                ? String(object.weightA)
                : "";
        message.amountB =
            object.amountB !== undefined && object.amountB !== null
                ? String(object.amountB)
                : "";
        message.weightB =
            object.weightB !== undefined && object.weightB !== null
                ? String(object.weightB)
                : "";
        message.vAmountA =
            object.vAmountA !== undefined && object.vAmountA !== null
                ? String(object.vAmountA)
                : "";
        message.vAmountB =
            object.vAmountB !== undefined && object.vAmountB !== null
                ? String(object.vAmountB)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined &&
            (obj.id = (message.id || long_1.default.UZERO).toString());
        message.amountA !== undefined && (obj.amountA = message.amountA);
        message.weightA !== undefined && (obj.weightA = message.weightA);
        message.amountB !== undefined && (obj.amountB = message.amountB);
        message.weightB !== undefined && (obj.weightB = message.weightB);
        message.vAmountA !== undefined && (obj.vAmountA = message.vAmountA);
        message.vAmountB !== undefined && (obj.vAmountB = message.vAmountB);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, basePoolReserve);
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromValue(object.id)
                : long_1.default.UZERO;
        message.amountA = (_a = object.amountA) !== null && _a !== void 0 ? _a : "";
        message.weightA = (_b = object.weightA) !== null && _b !== void 0 ? _b : "";
        message.amountB = (_c = object.amountB) !== null && _c !== void 0 ? _c : "";
        message.weightB = (_d = object.weightB) !== null && _d !== void 0 ? _d : "";
        message.vAmountA = (_e = object.vAmountA) !== null && _e !== void 0 ? _e : "";
        message.vAmountB = (_f = object.vAmountB) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
const atob = globalThis.atob ||
    ((b64) => globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
const btoa = globalThis.btoa ||
    ((bin) => globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr) {
        bin.push(String.fromCharCode(byte));
    }
    return btoa(bin.join(""));
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
